import { PropsWithChildren } from 'react';

import { AppSidebarLink } from './AppSidebarLink';
import { SidebarLinkProps } from './types';
import styles from '../AppLayout.module.scss';

type SidebarChildrenProps = PropsWithChildren<{
  childrenLinks?: SidebarLinkProps[];
}>;

export const SidebarChildren = ({
  childrenLinks,
  children,
}: SidebarChildrenProps) => (
  <div className={styles.childLinks}>
    {childrenLinks?.map((child) => (
      <AppSidebarLink key={child.label} {...child} isChild />
    ))}
    {children}
  </div>
);
